import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';

import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import axios from 'axios';


const SizeWiseMaterial = () => {
    const { Id } = useParams();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [material, setMaterial] = useState([]);
    const [sizeWise, setSizeWise] = useState([]);

    useEffect(() => {
        fetchSizeWiseMaterial(Id);
    }, [Id]);

    const fetchSizeWiseMaterial = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getItemMaterialList&imId=${id}`);
            setMaterial(res?.data?.data);
            setSizeWise(res?.data?.data2);
            // console.log(res?.data);
        } catch (error) {
            console.log(error);
        }
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    // console.log(material);

    return (
        <>

            <div style={{ margin: '1% 0.5%' }}>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>

                            <h3 className='centered-heading'>Size Wise Material Info</h3>
                            <div className="dashed-line"></div>
                            <table>
                                <tr>
                                    <td>Item</td>
                                    <td>{material?.itemNm}</td>
                                    <td>Brand</td>
                                    <td>{material?.brandNm}</td>
                                </tr>
                                <tr>
                                    <td>Material</td>
                                    <td>{material?.materialNm}</td>
                                </tr>
                            </table>


                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Size</TableCell>
                                            {sizeWise?.map((item, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.size}</TableCell>
                                            ))}
                                        </TableRow>


                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>{material?.materialNm}</TableCell>
                                            {sizeWise?.map((item, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center'>
                                                    {item.matsize}

                                                </TableCell>
                                            ))}
                                        </TableRow>


                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Qty</TableCell>
                                            {sizeWise?.map((item, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center'>
                                                    {item.qty}

                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default SizeWiseMaterial;
